import { replica } from '@/shared/sync/replica';
import type { Attachment } from './attachment';

/** Open the file in a new tab; false when its bytes are not on this device yet. */
export async function openAttachment(attachment: Attachment): Promise<boolean> {
  const stored = await replica.db.blobs.get(attachment.sha256);
  if (!stored) return false;
  const url = URL.createObjectURL(new Blob([stored.blob], { type: attachment.type }));
  window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return true;
}
